const theme = {
  token: {
    colorPrimary: '#1890ff',
    colorPrimaryBg: '#eff3f7',
    colorLink: '#1890ff',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#eff3f7',
  },
};

export default theme;
